import cBillingForm from '#themes/default/default/components/billingForm/billingForm.js';

import template from './payconiq.html' with { type: 'html' };

export default {
	name: 'CPayconiq',
	components: {
		cBillingForm
	},
	props: {
		customer: {
			type: Object,
			default: () => null
		},
		form: {
			type: Object,
			default: () => null
		},
		order: {
			type: Object,
			default: () => null
		},
		providerAccount: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	template
};
